import createVueComponent from '../createVueComponent';

const Play = createVueComponent('PlayIcon', [
  ['polygon', { points: '5 3 19 12 5 21 5 3', key: '191637' }],
]);

export default Play;
